var React = require('react');

function AlertDisable (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M9.051 3.77A6 6 0 0 1 18 9v4a1 1 0 1 0 2 0V9A8 8 0 0 0 8.069 2.03a1 1 0 0 0 .982 1.74zM14.586 16L6.168 7.582A6.006 6.006 0 0 0 6 9v5c0 .729-.195 1.412-.535 2h9.12zm2 2H2c-1.333 0-1.333-2 0-2a2 2 0 0 0 2-2V9.001a8 8 0 0 1 .582-3.005L.292 1.707A1 1 0 0 1 1.708.293l4.764 4.764a.99.99 0 0 1 .033.032l17.203 17.204a1 1 0 0 1-1.414 1.414L16.586 18zm-3.721 2.498a1 1 0 0 1 1.73 1.004 3 3 0 0 1-5.19 0 1 1 0 0 1 1.73-1.004 1 1 0 0 0 1.73 0z"}));
}

AlertDisable.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = AlertDisable;

AlertDisable.default = AlertDisable;
